import { graphql } from "@/lib/gql/__generated__";

export const HotelTemplateSettingsSkipMutation = graphql(/* GraphQL */ `
	mutation HotelTemplateSettingsSkip($input: HotelTemplateSettingsSkipInput!) {
		hotelTemplateSettingsSkip(input: $input) {
			userErrors
		}
	}
`);
